"use client";

import { c as _c } from "react/compiler-runtime";
import { SnackbarProvider } from "notistack";
import React, { type ReactNode } from "react";
import { TrpcProvider } from "#/shared/trpc/TrpcProvider";
import { SnackbarCloseButton } from "#/shared/ui/atoms/SnackbarCloseButton";
import { StateThemeProvider } from "#/shared/ui/providers/StateThemeProvider";
import { isSnackbarClosable } from "#/shared/ui/snackbarClosability";
import { ReduxProvider } from "#/store/provider";
import type { SsrDeviceType } from "#/themes";
type AppShellProvidersProps = {
  children: ReactNode;
  ssrDeviceType?: SsrDeviceType;
};

/**
 * Base client providers for all App Router layouts.
 * Apollo mounts per-route via {@link ApolloHydrationProvider} on daily/profile pages.
 * SessionProvider is mounted in SessionGate (inside LocaleAppLayout).
 */
export const AppShellProviders: React.FC<AppShellProvidersProps> = t0 => {
  const $ = _c(6);
  const {
    children,
    ssrDeviceType
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      containerAnchorOriginBottomLeft: "snackbar-mobile-bottom-margin",
      containerAnchorOriginBottomCenter: "snackbar-mobile-bottom-margin",
      containerAnchorOriginBottomRight: "snackbar-mobile-bottom-margin"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== children) {
    t2 = <SnackbarProvider maxSnack={4} action={_temp} classes={t1}>{children}</SnackbarProvider>;
    $[1] = children;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== ssrDeviceType || $[4] !== t2) {
    t3 = <TrpcProvider><ReduxProvider><StateThemeProvider ssrDeviceType={ssrDeviceType}>{t2}</StateThemeProvider></ReduxProvider></TrpcProvider>;
    $[3] = ssrDeviceType;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
};
function _temp(snackbarKey) {
  return isSnackbarClosable(snackbarKey) ? <SnackbarCloseButton snackbarKey={snackbarKey} /> : null;
}